import React from 'react';
import { twMerge } from 'tailwind-merge';

const Divider = ({ className = '' }) => (
  <div className={twMerge('border-slate-200 border-b', className)}></div>
);
export default Divider;
